import React, {useEffect, useState} from 'react'
import {useIdeationScope} from '../../../context/IdeationScope'
import {ideationApi} from '../../../../../api/ideationApi'
import styles from './IdeationResults.module.scss'
import {ReactComponent as TopVote} from '../../../../../assets/Icons/TopVote.svg'
import {cx} from '../../../../../utils'

import {IdeationResultsDefaultsIdea} from '../IdeationResultsDefaultsIdea/IdeationResultsDefaultsIdea'
import {IdeationResultsComments} from '../IdeationResultsComments/IdeationResultsComments'
import {NoData} from '../../../../../components/NoData/NoData'
import {WuTable} from '@npm-questionpro/wick-ui-lib'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../../../../Translation/English/global'
import {IDEATION} from '../../../../../Translation/English/ideation'
import type {IExploreIdea} from '../../../../../types'

export const IdeationResults: React.FC = () => {
  const {ideationId} = useIdeationScope()
  const {data: explore} = ideationApi.useExplore(ideationId)
  const {data: ideation} = ideationApi.useIdeation(ideationId)
  const wt = useWt()

  const [isShowIdeas] = useState<boolean>(true)
  const [crowdsourcesIdeas, setCrowdsourcesIdeas] = useState<IExploreIdea[]>([])

  useEffect(() => {
    const crowdsourcesIdeas: IExploreIdea[] = []
    explore?.questions?.forEach(question => {
      crowdsourcesIdeas.push(...(question.ideas ?? []))
    })
    setCrowdsourcesIdeas(crowdsourcesIdeas)
  }, [explore])

  return (
    <div className={styles.ideaFlowResults}>
      <div className={styles.ideaFlowResultsHeader}>
        <p className={styles.ideaFlowResultsHeaderIntroduction}>
          {ideation?.introduction}
        </p>
        <p className={'idea-flow-results--header--question'}>
          {ideation?.allowIdeas && ideation?.questions?.[0]?.question}
        </p>
      </div>
      <div className={styles.ideaFlowResultsTopIdeasProgress}>
        <div className={styles.ideaFlowResultsTopIdeas}>
          <div className={styles.ideaFlowResultsTopIdeasTitleBlock}>
            <TopVote
              width={18}
              height={24}
              fill={'#1b87e6'}
              className={'idea-flow-results--top-ideas--icon'}
            />
            <p className={styles.ideaFlowResultsTopIdeasProgressTitle}>
              {wt(IDEATION.topIdeas)}
            </p>
          </div>

          <div className={styles.ideaFlowResultsTopIdeasContent}>
            {explore?.topIdeas?.map((topIdea, index: number) => (
              <div
                key={topIdea.id}
                className={styles.ideaFlowResultsTopIdeasItem}
              >
                <div className={styles.ideaFlowResultsTopIdeasItemBlock1}>
                  <span className={styles.ideaFlowResultsTopIdeasItemIndex}>
                    #{index + 1}
                  </span>
                  <span className={styles.ideaFlowResultsTopIdeasItemName}>
                    {topIdea?.text}
                  </span>
                </div>
                <div className={'idea-flow-results--top-ideas--item-block-2'}>
                  <span className={styles.ideaFlowResultsTopIdeasItemVoteCount}>
                    {topIdea?.votesCount}{' '}
                    {topIdea?.votesCount > 1
                      ? String(wt(GLOBAL.votes))
                      : String(wt(GLOBAL.vote))}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.ideaFlowResultsProgress}>
          <p className={styles.ideaFlowResultsTopIdeasProgressTitle}>
            {wt(IDEATION.engagement)}
          </p>

          <div className={styles.ideaFlowResultsProgressContent}>
            <div className={styles.ideaFlowResultsProgressBlock}>
              <div className={styles.ideaFlowResultsProgressResult}>
                {explore?.participants}
              </div>
              <div>
                {explore?.participants != 1
                  ? String(wt(IDEATION.participants))
                  : String(wt(IDEATION.participant))}
              </div>
            </div>
            <div className={styles.ideaFlowResultsProgressBlock}>
              <div className={styles.ideaFlowResultsProgressResult}>
                {explore?.defaultIdeas?.length}
              </div>
              <div>
                {explore?.ideasCounts != 1
                  ? String(wt(IDEATION.ideas))
                  : String(wt(IDEATION.idea))}{' '}
              </div>
            </div>
            <div className={styles.ideaFlowResultsProgressBlock}>
              <div className={styles.ideaFlowResultsProgressResult}>
                {
                  explore?.defaultIdeas?.flatMap(idea => idea.comments || [])
                    .length
                }
              </div>
              <div>
                {explore?.comments != 1
                  ? String(wt(IDEATION.comments))
                  : String(wt(IDEATION.comment))}{' '}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={cx(
          styles.ideaFlowResultsIdeas,
          isShowIdeas && styles.openIdeas,
        )}
      >
        <div className={styles.ideaFlowResultsIdeasHeader}>
          <p className={'idea-flow-results--ideas--title'}>
            {wt(IDEATION.promotedIdeas)}
          </p>
        </div>

        <div className={styles.ideaFlowResultsIdeasBlock}>
          {explore?.defaultIdeas?.length ? (
            explore.defaultIdeas.map(defaultIdea => (
              <IdeationResultsDefaultsIdea
                key={defaultIdea.id}
                defaultIdea={defaultIdea}
              />
            ))
          ) : (
            <div className={styles.ideaFlowResultsIdeasNoData}>
              <NoData />
            </div>
          )}
        </div>

        <div className={styles.ideaFlowResultsCrowdsourcesIdeas}>
          <WuTable
            columns={[
              {
                accessorKey: 'text',
                header: `${wt(IDEATION.ideas)}`,
                enableSorting: true,
                cell: ({row}: {row: {original: IExploreIdea}}) => (
                  <>
                    <div>{row.original.text}</div>
                    <IdeationResultsComments idea={row.original} />
                  </>
                ),
              },
              {
                accessorKey: 'votesCount',
                header: `${wt(GLOBAL.votes)}`,
                enableSorting: true,
                cellAlign: 'center',
              },
            ]}
            data={crowdsourcesIdeas}
            NoDataContent={<NoData />}
          />
        </div>
      </div>
    </div>
  )
}
